import React from "react";
import "./FooterSection.css";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import Logo from "../Component/WhatsApp Image 2025-11-03 at 14.49.12_c1fd7792.jpg";

const Footer = () => {
  return (
    <>
      {/* Footer Start */}
      <div className="container-fluid position-relative overlay-top footer-bg text-white-50 py-5">
        <div className="container mt-5 pt-5">
          <div className="row gy-5">

            {/* Brand + About */}
            <div className="col-lg-4 col-md-12 footer-logo-section">
              <Link to="/" className="navbar-brand d-inline-flex align-items-center mb-3">
                <img src={Logo} alt="CPIT Logo" className="footer-logo" />
              </Link>

              <p className="m-0 mt-3" style={{ lineHeight: "1.7" }}>
                At CPIT, we don't just provide courses — we create career opportunities.
                Our programs help students, professionals, and job seekers upgrade skills
                and build a strong future.
              </p>

              <div className="footer-social mt-4">
                <a href="#"><FaXTwitter /></a>
                <a href="#"><FaFacebookF /></a>
                <a href="#"><FaLinkedinIn /></a>
                <a href="#"><FaInstagram /></a>
                <a href="#"><FaYoutube /></a>
              </div>
            </div>

            {/* Our Projects */}
            <div className="col-lg-4 col-md-6">
              <h3 className="text-white mb-4">Our Projects</h3>

              <div className="d-flex flex-column gap-2">
                <Link className="text-white-50" to="/nielit"><i className="fa fa-angle-right mr-2"></i>NIELIT</Link>
                <Link className="text-white-50" to="/upsdm"><i className="fa fa-angle-right mr-2"></i>UPSDM</Link>
                <Link className="text-white-50" to="/bsdm"><i className="fa fa-angle-right mr-2"></i>BSDM</Link>
                <Link className="text-white-50" to="/asdc"><i className="fa fa-angle-right mr-2"></i>ASDC</Link>
                <Link className="text-white-50" to="/pmkvy"><i className="fa fa-angle-right mr-2"></i>PMKVY</Link>
                <Link className="text-white-50" to="/csr"><i className="fa fa-angle-right mr-2"></i>CSR</Link>
                <Link className="text-white-50" to="/ddugky"><i className="fa fa-angle-right mr-2"></i>DDU-GKY</Link>
                <Link className="text-white-50" to="/ttsc"><i className="fa fa-angle-right mr-2"></i>TTSC</Link>
                <Link className="text-white-50" to="/ncvte"><i className="fa fa-angle-right mr-2"></i>NCVTE</Link>
                <Link className="text-white-50" to="/hrpolicy"><i className="fa fa-angle-right mr-2"></i>HR Policies</Link>
              </div>
            </div>

            {/* Contact */}
            <div className="col-lg-4 col-md-6">
              <h3 className="text-white mb-4">Get In Touch</h3>

              <p className="mb-3">
                <i className="fa fa-map-marker-alt mr-2"></i>
                Banshi Bazar, Chungi, Near Honda Agency, Varanasi Main Road, Ghazipur (UP) 233001
              </p>

              <p className="mb-3">
                <i className="fa fa-phone-alt mr-2"></i>+91-9919525333
              </p>

              <p className="mb-0">
                <i className="fa fa-envelope mr-2"></i>cpitgzp@gmail.com
              </p>
            </div>

          </div>
        </div>
      </div>
      {/* Footer End */}
    </>
  );
};

export default Footer;